var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobdetailsviewdebuginfo" }, [
    _c("div", { staticClass: "h4 mt-5" }, [_vm._v("Debug Information")]),
    _c("div", { staticClass: "h5" }, [_vm._v("Matched Occupations")]),
    _c(
      "table",
      [
        _vm._m(0),
        _vm._l(_vm.jobPosting.Occupations, function (occupation, index) {
          return _c("tr", [
            _c("td", { staticClass: "pr-3" }, [
              _vm._v(_vm._s(occupation.OccupationTitle)),
            ]),
            _c("td", [_vm._v(_vm._s(occupation.Score))]),
          ])
        }),
      ],
      2
    ),
    _c("div", { staticClass: "h5 mt-2" }, [_vm._v("Extracted Keywords")]),
    _c(
      "table",
      [
        _vm._m(1),
        _vm._l(_vm.jobPosting.Classifications, function (values, cat) {
          return _vm._l(values, function (keyword, key) {
            return _c("tr", [
              _c("td", { staticClass: "pr-3" }, [_vm._v(_vm._s(cat))]),
              _c("td", [_vm._v(_vm._s(keyword))]),
            ])
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Occupation")]),
      _c("th", [_vm._v("Score")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Category")]),
      _c("th", [_vm._v("Keyword")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }